import { render, staticRenderFns } from "./BetaForm.vue?vue&type=template&id=6cde1c54&scoped=true"
import script from "./BetaForm.vue?vue&type=script&lang=js"
export * from "./BetaForm.vue?vue&type=script&lang=js"
import style0 from "./BetaForm.vue?vue&type=style&index=0&id=6cde1c54&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cde1c54",
  null
  
)

export default component.exports